// src/pages/kpi/TurnCount.jsx

import React from "react";
import BaseKPIPage from "./BaseKPIPage";
import { KPI_PAGE_CONFIG } from "../constants/kpiConstants";
/**
 * Turn Count Analytics Page
 * Uses the reusable BaseKPIPage with specific configuration
 */
export default function TurnCount() {
  return (
    <BaseKPIPage
      config={KPI_PAGE_CONFIG.turnCount}
      showInterval={false}
      showEndDate={true}
      showAggregation={false}
    />
  );
}